// extracted by mini-css-extract-plugin
export default {"call-to-action-icon":"product-membors-view_call-to-action-icon__XFMXn","get-started":"product-membors-view_get-started__HfC4l"};